import ShareMsgBase from './A_G.ShareMsgBase';

class MsgLivesRequest extends ShareMsgBase {
  /**
   * The message that gets sent when you want to ask for lives
   * @param {string} user1AvatarUrl
   * @param {string} user2AvatarUrl
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1AvatarUrl, user2AvatarUrl, onAllImagesReadyCallback = null) {
    super(3, onAllImagesReadyCallback);

    this.avatar1 = this._addExtImage(506, 144, user1AvatarUrl, 0, 132, null);
    this.avatar2 = this._addExtImage(45, 155, user2AvatarUrl, 0, 132, null);
    this.bg = this._addExtImage(0, 0, 'img/Msg_Life_Request.png', 0, null, null);
  }
}

G.MsgLivesRequest = MsgLivesRequest;
